import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Footer from "../component/Footer";
import CommonTable from "../component/CommonTable";
import useIbStatus from "../hooks/useIbStatus";
import Loader from "../component/Loader";
import { formatDateDDMMYYYY } from "../utils/dateUtils";
import ExportButton from "../component/ExportButton";
import { exportToExcel } from "../utils/exportData";
import MobileFilter from "../component/MobileFilter";

export default function Withdrawal() {
  const [loading, setLoading] = useState(false);
  const mid = sessionStorage.getItem("mid");
  // const mid = 25; // -- testing

  const {
    ibStatus,
    ibLoading,
    isActive,
    isPending,
    isNotApplied
  } = useIbStatus(mid);

  const isPageLoading = ibLoading || loading;

  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    operation: "ALL",
  });
  const [searchTerm, setSearchTerm] = useState("");

  const clearFilters = () => {
    setFilters({
      fromDate: "",
      toDate: "",
      operation: "ALL",
    });
    setSearchTerm("");
  };

  useEffect(() => {
    // displayButtons(tableRef);
  }, []);
  return (
    <>
      <div id="layout-wrapper">
        {isPageLoading && <Loader />}
        <Topbar />
        <Sidebar />
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              {/* start page title */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h2 className="fw-700 mb-sm-0">Withdrawal</h2>
                  </div>
                </div>
              </div>
              {/* end page title */}
              {isActive && (
                <>
                  <div className="row">
                    <div className="col-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="d-flex flex-wrap align-items-end gap-2 mb-4 desktop-filter-row">
                            <div>
                              <label htmlFor="">Form</label>
                              <input
                                className="form-control"
                                type="date"
                                onKeyDown={(e) => e.preventDefault()}
                                value={filters.fromDate}
                                onChange={(e) => setFilters({ ...filters, fromDate: e.target.value })}
                                max={filters.toDate ? (filters.toDate > new Date().toISOString().split("T")[0] ? new Date().toISOString().split("T")[0] : filters.toDate) : new Date().toISOString().split("T")[0]}
                              />
                            </div>
                            <div>
                              <label htmlFor="">To</label>
                              <input
                                className="form-control"
                                type="date"
                                onKeyDown={(e) => e.preventDefault()}
                                value={filters.toDate}
                                onChange={(e) => setFilters({ ...filters, toDate: e.target.value })}
                                min={filters.fromDate || undefined}
                                max={new Date().toISOString().split("T")[0]}
                              />
                            </div>
                            <div>
                              <label htmlFor="">Operation</label>
                              <select
                                className="form-select"
                                value={filters.operation}
                                onChange={(e) => setFilters({ ...filters, operation: e.target.value })}
                              >
                                <option value="ALL">ALL</option>
                                <option value="Deposits">Deposits</option>
                                <option value="Withdrawal">Withdrawal</option>
                                <option value="Transfer">Transfer</option>
                                <option value="IB Commission">IB Commission</option>
                              </select>
                            </div>
                            <div>
                              <label htmlFor="">Search</label>
                              <input
                                className="form-control"
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                              />
                            </div>
                            <div>
                              <button
                                type="button"
                                className="btn btn-primary waves-effect waves-light"
                                onClick={() => { }}
                              >
                                Search
                              </button>
                            </div>
                            <div>
                              <button
                                type="button"
                                className="btn btn-primary waves-effect waves-light"
                                onClick={clearFilters}
                                disabled={!filters.fromDate && !filters.toDate && filters.operation === "ALL" && !searchTerm}
                              >
                                Clear
                              </button>
                            </div>
                            <div className="ms-auto">
                              <ExportButton 
                                onClick={() => exportToExcel([], "Withdrawal_History", "default")}
                              />
                            </div>
                          </div>

                          <MobileFilter
                            title="History"
                            onExport={() => exportToExcel([], "Withdrawal_History", "default")}
                          >
                            <div>
                              <label htmlFor="">Form</label>
                              <input
                                className="form-control"
                                type="date"
                                onKeyDown={(e) => e.preventDefault()}
                                value={filters.fromDate}
                                onChange={(e) => setFilters({ ...filters, fromDate: e.target.value })}
                                max={filters.toDate ? (filters.toDate > new Date().toISOString().split("T")[0] ? new Date().toISOString().split("T")[0] : filters.toDate) : new Date().toISOString().split("T")[0]}
                              />
                            </div>
                            <div>
                              <label htmlFor="">To</label>
                              <input
                                className="form-control"
                                type="date"
                                onKeyDown={(e) => e.preventDefault()}
                                value={filters.toDate}
                                onChange={(e) => setFilters({ ...filters, toDate: e.target.value })}
                                min={filters.fromDate || undefined}
                                max={new Date().toISOString().split("T")[0]}
                              />
                            </div>
                            <div>
                              <label htmlFor="">Operation</label>
                              <select
                                className="form-select"
                                value={filters.operation}
                                onChange={(e) => setFilters({ ...filters, operation: e.target.value })}
                              >
                                <option value="ALL">ALL</option>
                                <option value="Deposits">Deposits</option>
                                <option value="Withdrawal">Withdrawal</option>
                                <option value="Transfer">Transfer</option>
                                <option value="IB Commission">IB Commission</option>
                              </select>
                            </div>
                            <div>
                              <label htmlFor="">Search</label>
                              <input
                                className="form-control"
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                              />
                            </div>
                            <div className="d-flex gap-2 mt-2">
                              <button
                                type="button"
                                className="btn btn-primary waves-effect waves-light flex-grow-1"
                                onClick={() => { }}
                                data-bs-dismiss="offcanvas"
                                data-bs-target="#filterOffcanvasMobile"
                              >
                                Search
                              </button>
                              <button
                                type="button"
                                className="btn btn-light waves-effect waves-light border flex-grow-1"
                                onClick={clearFilters}
                                disabled={!filters.fromDate && !filters.toDate && filters.operation === "ALL" && !searchTerm}
                                data-bs-dismiss="offcanvas"
                                data-bs-target="#filterOffcanvasMobile"
                              >
                                Clear
                              </button>
                            </div>
                          </MobileFilter>
                          <CommonTable
                            columns={[
                              { header: "Operation", accessor: "operation" },
                              { header: "Payment From", accessor: "payment_from" },
                              { header: "Payment To", accessor: "payment_to" },
                              { header: "Amount", accessor: "amount" },
                              { header: "Currency", accessor: "currency" },
                              { header: "Tx.Date", render: (row) => row.tx_date ? formatDateDDMMYYYY(row.tx_date) : "-" },
                              { header: "Status", accessor: "status" },
                              { header: "Action", accessor: "action" }
                            ]}
                            data={[]}
                            loading={loading}
                          />
                        </div>
                      </div>
                    </div>{" "}
                    {/* end col */}
                    <div>
                      {/* modal */}
                      <div
                        className="modal fade bs-example-modal-center"
                        tabIndex={-1}
                        role="dialog"
                        aria-hidden="true"
                      >
                        <div className="modal-dialog modal-dialog-centered">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5 className="modal-title">Transaction Details</h5>
                              <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                              />
                            </div>
                            <div className="modal-body">
                              <CommonTable
                                hideHeader={true}
                                columns={[
                                  { accessor: "label", render: (row) => row.label },
                                  { accessor: "value", className: "fw-bold notranslate", render: (row) => <span className="notranslate" translate="no">{row.value}</span> }
                                ]}
                                data={[
                                  { label: "Transaction ID", value: "TXjqx0006665" },
                                  { label: "From Account", value: "Tether USD (USDT TRC20)" },
                                  { label: "To Account", value: "91020" },
                                  { label: "Currency", value: "USD" },
                                  { label: "Amount", value: "100.00" },
                                  { label: "Commission(%)", value: "0.0" },
                                  { label: "Commission Amount", value: "0.0" },
                                  { label: "Net Amount", value: "100.00" },
                                  { label: "Transaction Date", value: "2024-08-20" },
                                  { label: "Modified Date", value: "2024-08-20" },
                                  { label: "Status", value: "Completed" },
                                  { label: "Reject", value: "Payments" },
                                ]}
                                tableClassName="table mb-0 border"
                              />
                              <div className="card">
                                <div className="mt-4">
                                  <div className="text-muted text-center">
                                    <div className="bg-primary-subtle p-3">
                                      <h4 className="card-title mb-0">
                                        Payment Details
                                      </h4>
                                    </div>
                                  </div>
                                  <div className="table-responsive mt-4">
                                    <CommonTable
                                      hideHeader={true}
                                      columns={[
                                        { accessor: "label", render: (row) => row.label },
                                        { accessor: "value", className: "fw-bold", render: (row) => row.value }
                                      ]}
                                      data={[
                                        { label: "Transaction Hash", value: "sdfsfsdfsdfd" },
                                        {
                                          label: "Deposit Receipt", value: (
                                            <a href="#" className="btn btn-sm btn-soft-success">
                                              <i className="mdi mdi-eye-outline fs-5" />
                                            </a>
                                          )
                                        }
                                      ]}
                                      tableClassName="table align-middle mb-0"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* /.modal-content */}
                        </div>
                        {/* /.modal-dialog */}
                      </div>
                      {/* /.modal */}
                    </div>
                  </div>
                </>
              )}

              {isPending && (
                <>
                  <div className="row justify-content-center">
                    <div
                      className="alert alert-warning alert-dismissible fade show"
                      role="alert"
                      style={{
                        backgroundColor: "#fff3cd",
                        borderColor: "#ffeeba",
                        color: "#856404",
                        marginBottom: "1.5rem",
                      }}
                    >
                      <i className="mdi mdi-timer-sand-full me-2" />
                      Your IB Account application status is <strong>pending</strong>. Please
                      allow up to 24 hours for verification and approval.
                    </div>
                  </div>
                </>
              )}

              {isNotApplied && (
                <>
                  <div className="row justify-content-center">
                    <div
                      className="alert alert-warning alert-dismissible fade show"
                      role="alert"
                      style={{
                        backgroundColor: "#fff3cd",
                        borderColor: "#ffeeba",
                        color: "#856404",
                        marginBottom: "1.5rem",
                      }}
                    >
                      <i className="mdi mdi-timer-sand-full me-2" />
                      You have <strong>not applied</strong> for an IB Account yet.
                      Please submit your IB application to get started.
                    </div>
                  </div>
                </>
              )}
            </div>
            {/* container-fluid */}
          </div>

          {/* End Page-content */}
          <Footer />
        </div>
      </div>
    </>
  );
}
